export default __webpack_public_path__ + "static/media/Enquiries.911b7a45.pdf";